import { useEffect, useState } from "react";

const SPLASH_IMG = "https://static.prod-images.emergentagent.com/jobs/55f634fb-7cfc-429a-9e9b-faaf578e2dbd/images/6a53247a916246b7c27d4710878ace2e6cebe81a9b9c8f1462eff69ce3f9859f.jpeg";

export default function Splash() {
  const [show, setShow] = useState(() => !sessionStorage.getItem("svk_splash_seen"));
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (!show) return;
    const t1 = setTimeout(() => setFade(true), 1700);
    const t2 = setTimeout(() => { setShow(false); sessionStorage.setItem("svk_splash_seen", "1"); }, 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);

  if (!show) return null;
  return (
    <div className={`fixed inset-0 z-[100] flex items-center justify-center bg-[#1C1917] transition-opacity duration-500 ${fade ? "opacity-0 pointer-events-none" : "opacity-100"}`} data-testid="pwa-splash">
      <img src={SPLASH_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-35" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1C1917] via-[#1C1917]/70 to-[#1C1917]/30" />
      <div className="relative text-center px-6">
        <img src="/icons/icon-192.png" alt="SUVIKKA" className="w-16 h-16 rounded-2xl mx-auto shadow-2xl" />
        <p className="font-display text-3xl sm:text-4xl font-semibold tracking-[0.22em] text-white mt-5">SUVIKKA</p>
        <p className="text-[11px] tracking-[0.35em] uppercase text-[#6A1B29] font-semibold mt-2">Everything She Loves</p>
        <div className="w-10 h-px bg-[#6A1B29]/60 mx-auto mt-6" />
      </div>
    </div>
  );
}
